<template>
  <span class="svg-icon-flage">
    <svg v-if="isSolid" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.3198 7.16L7.47155 3.7V2.75C7.47155 2.34 7.138 2 6.73578 2C6.33355 2 6 2.34 6 2.75V21.25C6 21.66 6.33355 22 6.73578 22C7.138 22 7.47155 21.66 7.47155 21.25V17.29L15.5356 13.23C15.5356 13.23 15.5356 13.23 15.5455 13.23C17.174 12.37 18.0471 11.26 17.998 10.09C17.949 8.92 16.9974 7.88 15.3198 7.16Z" :fill="color" :stroke="color" stroke-width="1.5"/>
    </svg>
    <svg v-else :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 2.75C7.5 2.33579 7.16421 2 6.75 2C6.33579 2 6 2.33579 6 2.75V21.2521C6 21.6663 6.33579 22.0021 6.75 22.0021C7.16421 22.0021 7.5 21.6663 7.5 21.2521V17.3236C7.51658 17.317 7.53304 17.3097 7.54936 17.3019L15.3981 13.5089L15.3981 13.509L15.4098 13.5031C16.9503 12.7253 18.0319 11.5998 17.9964 10.2468C17.9607 8.88466 16.8101 7.82656 15.1724 7.14634L7.51505 3.90941C7.51004 3.90729 7.50503 3.90523 7.5 3.90323V2.75ZM7.5 5.53156V15.6597L14.7394 12.1613C16.1257 11.4598 16.5087 10.7365 16.4969 10.2861C16.4854 9.84499 16.0768 9.14575 14.5951 8.53079L14.5906 8.52891L14.5906 8.5289L7.5 5.53156Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isSolid: { type: Boolean },
  }
}
</script>